import Avatar from '@mui/joy/Avatar'
import Typography from '@mui/joy/Typography'
import React from 'react'

type EmptyStampProps = {
  textColor: string
}

function EmptyStamp(props: EmptyStampProps) {
  return (
    <>
      <Avatar
        size="lg"
        variant="outlined"
        sx={{
          border: `2px solid ${props.textColor}`,
        }}
      >
        {' '}
      </Avatar>
      <Typography
        level="body-sm"
        textColor={props.textColor}
        sx={{ pt: 0.5, color: props.textColor }}
        fontSize={16}
      >
        <>&nbsp;</>
      </Typography>
    </>
  )
}

export default EmptyStamp
